import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { removeSpacesFromString } from './utils';

const invalidPhoneAreaCodes = ['+670', '+324'];

/**
 * Check that phone number is a valid phone number
 * @param number phone number to be validated
 * @returns true or false
 */
export const isValidLoginPhoneNumber = (number: string): boolean => {
  // Use this to remove spaces from number
  number = removeSpacesFromString(number);
  // Use libphonenumber-js library for phone number validation, also used in server
  return (
    !invalidPhoneAreaCodes.some((code) => number.startsWith(code)) &&
    isValidPhoneNumber(number)
  );
};

/**
 * Return phone number without additional zeros
 * @param number for example +3580401234567
 * @returns phone number from which zeros have been removed, for example +358401234567
 */
export const getValidPhoneNumber = (number: string): string => {
  const phoneNumber = parsePhoneNumber(number);
  if (phoneNumber) return phoneNumber.number;
  return '';
};
